import React from 'react';
import { MENU_LANG_META, menuFlagUrl } from '../lib/menuLocale';

export function MenuFlag({ code, size = 28, className = '', title }) {
    const meta = MENU_LANG_META[code];
    if (!meta) return null;
    const height = Math.round(size * 0.72);
    return (
        <img
            src={menuFlagUrl(code, size <= 24 ? 40 : 80)}
            width={size}
            height={height}
            alt={meta.native}
            title={title || meta.native}
            className={`menu-flag${className ? ` ${className}` : ''}`}
            loading="lazy"
            decoding="async"
        />
    );
}

export function MenuLanguageFlagsBar({ enabled = ['ro', 'en'], value, onChange, label = 'Language', changing = false }) {
    const langs = (enabled || ['ro', 'en']).filter((code) => MENU_LANG_META[code]);
    if (langs.length <= 1) return null;

    const pick = async (code) => {
        if (code === value || changing) return;
        await onChange(code);
    };

    return (
        <div className="menu-flags-bar" role="group" aria-label={label} data-testid="menu-language-flags">
            {langs.map((code) => {
                const meta = MENU_LANG_META[code];
                const active = code === value;
                return (
                    <button
                        key={code}
                        type="button"
                        className={`menu-flags-bar__btn${active ? ' menu-flags-bar__btn--active' : ''}`}
                        onClick={() => pick(code)}
                        disabled={changing}
                        aria-label={meta.native}
                        aria-pressed={active}
                        title={meta.native}
                        data-testid={`menu-lang-${code}`}
                    >
                        <MenuFlag code={code} size={32} />
                    </button>
                );
            })}
        </div>
    );
}
